export const GAMEPLAY_ACCESS_EVENT = 'gameplay-access-updated';
export const WEEKLY_ACCESS_REASON = 'ANONYMOUS_WEEKLY_LIMIT_REACHED';
export const EXPIRED_ACCESS_REASON = 'ANONYMOUS_TRIAL_EXPIRED';
export const ACCESS_MESSAGES = {
  [WEEKLY_ACCESS_REASON]: 'Hai già giocato 5 partite negli ultimi 7 giorni. Crea un account gratuito per iniziare un’altra partita.',
  [EXPIRED_ACCESS_REASON]: 'Sono trascorsi 30 giorni dalla tua prima partita. Crea un account gratuito per continuare a giocare.',
};

let ownerGeneration = 0;
export const resetGameplayAccessOwner = () => { ownerGeneration += 1; };
export const captureGameplayAccessOwner = () => ownerGeneration;

export const publishGameplayAccess = (response, generation) => {
  if (response?.access && generation === ownerGeneration && typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(GAMEPLAY_ACCESS_EVENT, { detail: { response, generation } }));
  }
  return response;
};

export const isGameplayAccessReason = (reason) => Object.prototype.hasOwnProperty.call(ACCESS_MESSAGES, reason);
